import { BlockService } from '@blocksuite/block-std';
import { queryUrlDataFromAffineWorker } from './utils.js';
export class BookmarkService extends BlockService {
    constructor() {
        super(...arguments);
        this.queryUrlData = async (url) => {
            return queryUrlDataFromAffineWorker(url);
        };
    }
}
//# sourceMappingURL=bookmark-service.js.map